/* Yappa SEO: this script is now lazy-loaded on first user interaction
   (see the deferred-asset bootstrap in layout/theme.liquid). The old
   top-level `document.addEventListener('DOMContentLoaded', …)` wrapper
   never fired because DOMContentLoaded has already fired by the time
   interaction triggers the load. Swapped for the standard readyState
   check so init runs correctly in both pre- and post-DOMContentLoaded
   load paths. */
(function () {
  function init() {
    document.querySelectorAll('.yappa-credits-toggle').forEach(function (toggle) {
      toggle.addEventListener('change', function () {
        var applying = this.checked;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: { yappa_apply_credits: applying ? 'true' : 'false' }
          })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { open: true }
          }));
        });
      });
    });
  }
  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
